import Resource from '@/api/resources/Resource'

class LoggedInPersonnelEventsServices extends Resource {
    async updateLoggedInPersonnelEvent(request, personnelEventId) {
        const response = await this.axios.put(`/common/personnelEvents/${personnelEventId}`, request)
        return response.data
    }
    async createLoggedInPersonnelEvent(request) {
        const response = await this.axios.post(`/common/personnelEvents/`, request)
        return response.data
    }
    async deleteLoggedInPersonnelEvent(personnelEventId) {
        const response = await this.axios.delete(`/common/personnelEvents/${personnelEventId}`)
        return response.data
    }
    async getAllUnconfirmedLoggedInPersonnelEvents() {
        const response = await this.axios.get(`/common/personnelEvents/unconfirmed`)
        return response.data
    }
    async getAllLoggedInPersonnelEventsByDateRange(params) {
        const response = await this.axios.get(`/common/personnelEvents`, { params })
        return response.data
    }
}

export default new LoggedInPersonnelEventsServices()
